import { IPet } from 'types/Pet';
import { maskDecimalNumber } from 'util/masks';

import { Box, Grid, GridProps, Typography } from '@mui/material';

import { Format } from '../../../../helpers/Format';
import React from 'react';

export const PetTreatmentInformationsItem: React.FC<{
  name: string;
  value: React.ReactNode;
}> = ({ name, value }) => (
  <Box key={name} alignSelf="flex-start">
    <Typography sx={{ color: '#5B5B5B', fontSize: 14 }}>{name}</Typography>

    <Typography sx={{ color: '#4B4B4B', fontSize: 16, fontWeight: 500 }}>
      {value}
    </Typography>
  </Box>
);

interface Props extends GridProps {
  pet: IPet;
  tutorName: string;
  planName?: string;
}

export const PetTreatmentInformations: React.FC<Props> = ({
  pet,
  tutorName,
  planName,
  ...props
}) => {
  const castrated =
    pet.castrated === undefined
      ? 'Não informado'
      : pet.castrated
      ? 'Sim'
      : 'Não';

  return (
    <Grid container {...props}>
      <Grid item container spacing={2} md={12}>
        <Grid item md={3}>
          <PetTreatmentInformationsItem
            name="Nome do tutor"
            value={tutorName}
          />
        </Grid>

        <Grid item md={3}>
          <PetTreatmentInformationsItem name="Nome do plano" value={planName} />
        </Grid>

        <Grid item md={3}>
          <PetTreatmentInformationsItem name="Nome do pet" value={pet.name} />
        </Grid>

        <Grid item md={2}>
          <PetTreatmentInformationsItem name="Espécie" value={pet.specie} />
        </Grid>

        <Grid item md={1}>
          <PetTreatmentInformationsItem name="Sexo" value={pet.gender} />
        </Grid>
      </Grid>

      <Grid item container spacing={2} md={12} mt={3}>
        <Grid item md={3}>
          <PetTreatmentInformationsItem
            name="Idade"
            value={Format.petAge(new Date(pet.birthDate))}
          />
        </Grid>
        <Grid item md={3}>
          <PetTreatmentInformationsItem
            name="Raça"
            value={pet.race ? pet.race : 'Não informado'}
          />
        </Grid>

        <Grid item md={3}>
          <PetTreatmentInformationsItem
            name="Peso"
            value={`${maskDecimalNumber(pet.weight)} kg`}
          />
        </Grid>

        <Grid item md={3}>
          <PetTreatmentInformationsItem name="Castração" value={castrated} />
        </Grid>

        <Grid item md={3}>
          <PetTreatmentInformationsItem
            name="Temperamento"
            value={pet.temperament ? pet.temperament : 'Não informado'}
          />
        </Grid>

        <Grid item md={4}>
          <Box maxWidth={480}>
            <Typography
              sx={{ color: '#5B5B5B', fontSize: 14, marginBottom: '4px' }}
            >
              Observações
            </Typography>
            <Typography
              sx={{ color: '#757575', fontSize: 12, fontWeight: 400 }}
            >
              {pet?.observations}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
